import { render, staticRenderFns } from "./PapasMergeCard.vue?vue&type=template&id=71db5650&scoped=true&"
import script from "./PapasMergeCard.vue?vue&type=script&lang=js&"
export * from "./PapasMergeCard.vue?vue&type=script&lang=js&"
import style0 from "./PapasMergeCard.vue?vue&type=style&index=0&id=71db5650&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71db5650",
  null
  
)

export default component.exports